import { TranslateService } from '@ngx-translate/core'
import { APP_INJECTOR } from 'app.module'
import { BaseDecorator } from './base.decorator'
import { Document } from 'models'

export class DocumentDecorator extends BaseDecorator {
  private translateService: TranslateService

  constructor(protected object: Document) {
    super(object)

    this.translateService = APP_INJECTOR.get(TranslateService)
  }

  number(): string {
    return this.object && this.object.number ? this.object.number : ''
  }

  authority(): string {
    return this.object && this.object.authority ? this.object.authority : ''
  }

  homeAddress(): string {
    return this.object && this.object.homeAddress ? this.object.homeAddress : ''
  }

  kind(): string {
    return this.object && this.object.kind ? this.translateService.instant('documents.kinds.' + this.object.kind) : null
  }

  issuedAt(format: string): string {
    return this.object && this.object.issuedAt ? this.object.issuedAt.format(format) : ''
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/decorators/document.decorator.ts